<template>
    <div class="my-5 pt-md-4">
        <div class="border px-3 py-4 rounded bg-light">
            <h5 class="font-weight-bolder kova-text">Connect with Talents</h5>
            <div class="">
                <a-input class="mt-3 w-100" size="large" placeholder="Work Email" ref="searchInput"></a-input> 
            </div>
            <div class="">
                <a-input class="mt-3 w-100" size="large" type="password" placeholder="Password" ref="searchInput"></a-input> 
            </div>
            <div class="">
                <a-input class="mt-3 w-100" size="large" type="password" placeholder="Confirm Password" ref="searchInput"></a-input> 
            </div>
            <button class="btn-kovatek px-5 py-2 mt-4 add-rounded">Sign Up</button>
        </div>
    </div>
</template>

<script>

export default {
    
}
</script>

<style scoped>

</style>